import { FormItem as AntFormItem } from "@formily/antd-v5";
import { connect } from "@formily/react";

export const FormItem = connect((props) => {
  const enhancedProps = {
    ...props,
    colon: false,
    layout: "vertical",
  };

  return <AntFormItem {...enhancedProps} />;
});
